<mat-toolbar>
  <label>
    <input type="checkbox" #menuToggle>
    <span class="menu"><span class="hamburger"></span></span>
    <ul>
      <li *ngFor="let item of menuItems" class="with-icon">
        <mat-icon>{{ item.icon }}</mat-icon>
        <a class="mt-3 ml-2" [routerLink]="item.link" (click)="closeMenu()">
          {{ item.label | translate }}
        </a>
      </li>
    </ul>
  </label>

  <div class="logo">
    <img src="./../assets/images/logos/accept-logo.png" alt="Accept Logo">
  </div>

  <span class="app-tool-name d-none d-sm-block">Citizen App</span>

  <span class="spacer"></span>

  <div class="row align-items-center">
    <button mat-icon-button [routerLink]="'/pages/notifications'" class="icon">
      <img src="./../assets/images/svgs/notifications.png" width="26" height="26">
      <span class="badge" *ngIf="notifications > 0">{{ notifications }}</span>
    </button>

    <div class="lang-dropdown">
      <button mat-icon-button class="dropdown-toggle p-0" type="button" id="languageDropdown" data-toggle="dropdown">
        <img class="public-icon mr-2" [src]="'./../assets/images/svgs/' + selectedLanguageFlag + '.svg'" width="20"
          height="20">
      </button>
      <div class="dropdown-menu" aria-labelledby="languageDropdown">
        <button class="dropdown-item p-2" *ngFor="let language of languages" (click)="onChange(language.code)"
          [ngClass]="{'selected-option': language.isSelected}">
          <img class="mr-2" [src]="language.flag" width="20" height="20">
          {{ language.name }}
        </button>
      </div>
    </div>

    <div class="logout">
      <button class="logout-btn p-0">
        <div class="profile-container">
          <img src="./../assets/images/svgs/profile.png" width="27" height="27" alt="Profile">
          <span class="gamification-badge">{{gamification?.level}}</span>
        </div>
        <span class="username">{{user.name}}</span>
      </button>
      <div class="logout-content">
        <div class="d-flex"
          *ngFor="let item of [{icon: 'person', link: '/pages/my-account', text: 'app.my-account' | translate}, {icon: 'logout', link: '/auth/login', text: 'app.logout' | translate}]">
          <mat-icon class="m-2">{{ item.icon }}</mat-icon>
          <a routerLink="{{ item.link }}" (click)="item.icon === 'logout' && logout()">{{ item.text }}</a>
        </div>
      </div>
    </div>
  </div>
</mat-toolbar>